/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { IExercise, IExercisesStats, IMuscleGroup } from '../domains/Exercise';
import { IPaginatedResponse } from '../domains/Pagination';
import { api } from './api';

interface IGetExercisesOfGymParams {
  page?: number;
  limit?: number;
  search?: string;
  muscle_group_id?: string;
}

type IExercisesListResponse = IPaginatedResponse<IExercise> & {
  stats: IExercisesStats;
};

interface ICreateExercisePayload {
  name: string;
  muscle_groups: IExercise['muscle_groups'];
  description?: string;
}

interface IUpdateExercisePayload extends ICreateExercisePayload {
  id: string;
}

class ExercisesService {
  private apiService = api;

  public async getMuscleGroups() {
    return this.apiService.get<IMuscleGroup[]>('exercises/muscle_groups');
  }

  public async getExercisesOfGym(params: IGetExercisesOfGymParams = {}) {
    return this.apiService.get<IExercisesListResponse>('exercises', {
      params,
    });
  }

  public async getExerciseById(id: string) {
    return this.apiService.get<IExercise>(`exercises/${id}`);
  }

  public async createExercise(data: ICreateExercisePayload) {
    return this.apiService.post(`exercises`, {
      name: data.name,
      muscle_groups: data.muscle_groups,
      description: data.description,
    });
  }

  public async updateExercise(data: IUpdateExercisePayload) {
    return this.apiService.put(`exercises/${data.id}`, {
      name: data.name,
      description: data.description,
      muscle_groups: data.muscle_groups,
    });
  }
}

export { ExercisesService };
